import Com from "components/styledComp/CommStyledComp";
import React from "react";

const SaaSOverview = () => {
  return (
    <Com.DivDetailSection border="false">
      <Com.DivDetailHeading>
        <Com.DetailHeading>클라우드·SaaS 역량</Com.DetailHeading>
        <Com.DetailHeadingSmall>
          온프레미스·단말기 중심에서 구독형 클라우드 서비스로의 전환
        </Com.DetailHeadingSmall>
      </Com.DivDetailHeading>
      <div className="preview-tag-list">
        <Com.BtnTagList width="140px" disabled="disabled"> 멀티 테넌트 </Com.BtnTagList>
        <Com.BtnTagList width="120px" disabled="disabled"> 자동 확장 </Com.BtnTagList>
        <Com.BtnTagList width="140px" disabled="disabled"> 지속 배포 </Com.BtnTagList>
      </div>
      <div className="preview-tag-list">
        <Com.BtnTagList width="160px" disabled="disabled"> 서버 구축 최소화 </Com.BtnTagList>
        <Com.BtnTagList width="140px" disabled="disabled"> 운영 효율화 </Com.BtnTagList>
      </div>
    </Com.DivDetailSection>
  );
};

export default SaaSOverview;
